import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Calendar, MapPin, X } from 'lucide-react';
import { mockEvents } from '../utils/mockData';

const Events = () => {
  const { t, i18n } = useTranslation();
  const currentLang = i18n.language;
  const [selectedEvent, setSelectedEvent] = useState(null);

  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="container mx-auto px-4">
        <h1 className="text-4xl md:text-5xl font-bold text-center mb-4 text-gray-900">
          {t('events.title')}
        </h1>
        <p className="text-center text-xl text-gray-600 mb-12">
          {t('events.subtitle')}
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
          {mockEvents.map((event) => (
            <div
              key={event.id}
              className="bg-white rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 cursor-pointer transform hover:-translate-y-1"
              onClick={() => setSelectedEvent(event)}
            >
              <div className="relative overflow-hidden group">
                <img
                  src={event.coverImage}
                  alt={event[`title${currentLang.charAt(0).toUpperCase() + currentLang.slice(1)}`]}
                  className="w-full h-64 object-cover transform group-hover:scale-110 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-black bg-opacity-40 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                  <span className="text-white text-lg font-semibold">
                    {t('events.viewGallery')}
                  </span>
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-semibold mb-3 text-gray-900">
                  {event[`title${currentLang.charAt(0).toUpperCase() + currentLang.slice(1)}`]}
                </h3>
                <div className="space-y-2">
                  <div className="flex items-center text-gray-600">
                    <Calendar size={18} className="mr-2 text-red-600" />
                    <span>{new Date(event.date).toLocaleDateString()}</span>
                  </div>
                  <div className="flex items-center text-gray-600">
                    <MapPin size={18} className="mr-2 text-red-600" />
                    <span>{event.location}</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Gallery Modal */}
      {selectedEvent && (
        <div className="fixed inset-0 bg-black bg-opacity-90 z-50 flex items-center justify-center p-4">
          <div className="relative w-full max-w-5xl">
            <button
              onClick={() => setSelectedEvent(null)}
              className="absolute -top-12 right-0 text-white hover:text-red-500 transition-colors"
            >
              <X size={32} />
            </button>
            <div className="bg-white rounded-lg overflow-hidden">
              <div className="p-6 border-b border-gray-200">
                <h2 className="text-2xl font-bold text-gray-900">
                  {selectedEvent[`title${currentLang.charAt(0).toUpperCase() + currentLang.slice(1)}`]}
                </h2>
                <div className="flex items-center space-x-6 mt-3 text-gray-600">
                  <div className="flex items-center">
                    <Calendar size={18} className="mr-2 text-red-600" />
                    <span>{new Date(selectedEvent.date).toLocaleDateString()}</span>
                  </div>
                  <div className="flex items-center">
                    <MapPin size={18} className="mr-2 text-red-600" />
                    <span>{selectedEvent.location}</span>
                  </div>
                </div>
              </div>
              <div className="p-6 max-h-[70vh] overflow-y-auto">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  {selectedEvent.images.map((image, index) => (
                    <img
                      key={index}
                      src={image}
                      alt={`Event ${index + 1}`}
                      className="w-full h-64 object-cover rounded-lg"
                      onContextMenu={(e) => e.preventDefault()}
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Events;
